/**
 * ViewAsBanner - Shows when admin is viewing as another creator
 */

import { Button } from "@/components/ui/button";
import { Eye, X } from "lucide-react";

interface ViewAsBannerProps {
  creatorName: string;
  onExit: () => void;
}

export function ViewAsBanner({ creatorName, onExit }: ViewAsBannerProps) {
  return (
    <div className="bg-amber-100 dark:bg-amber-900/30 border-b border-amber-300 dark:border-amber-700 px-4 py-2">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4 text-amber-700 dark:text-amber-400" />
          <span className="text-amber-900 dark:text-amber-200 font-medium text-sm">
            Viewing as: {creatorName}
          </span>
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onExit}
          className="h-7 text-xs bg-white dark:bg-amber-900/50 border-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/70"
        >
          <X className="h-3 w-3 mr-1" />
          Exit View As
        </Button>
      </div>
    </div>
  );
}
